import { Injectable } from '@angular/core';
import { ObservatoryService } from '../observatory/observatory.service';

@Injectable()
export class NotificationsService {

  constructor(
    public _observatoryService: ObservatoryService
  ) { }

  setSuccess(msg: string): void {
    this._observatoryService.setData('messagesData', { type: 'successMessage', message: msg });
  }

  setError(msg: string): void {
    this._observatoryService.setData('messagesData', { type: 'errorMessage', message: msg });
  }

  setWarning(msg: string): void {
    this._observatoryService.setData('messagesData', { type: 'warningMessage', message: msg });
  }

}
